<template>
  <div>
    <HeadBar /><!--顶部bar-->
    <!--顶部logo、检索-->
    <HeadNav /><!-- 顶部导航-->
    <div class="con">
      <div class="con-inner">
        <ClassCate @typeChange="cateChange" />
        <div class="con-search">
          <SearchBarCircle
            :num="totalItem"
            v-model="searchKey"
            @btnClick="searchBarClick"
            placeholder="请输入关键字"
          />
        </div>
        <div class="con-lists">
          <Course v-for="(item, index) in lists" :key="index" :data="item" />
        </div>
      </div>
      <Pagination
        :total="totalItem"
        :page="page"
        @pageIndexChange="handlePageChange"
      />
    </div>

    <FootBar class="footer" />
  </div>
</template>
<script>
import Pagination from "@/components/Pagination/index";
import ClassCate from "./components/ClassCate.vue";
import Course from "@/components/CourseItem/index.vue";
import SearchBarCircle from "@/components/SearchBarCircle/index";

// import Banner from "./components/Banner.vue";
import { getTrainList } from "@/api/onlineTrain";
export default {
  components: {
    ClassCate,
    Pagination,
    Course,
    SearchBarCircle,
    // Banner,
  },
  data() {
    return {
      totalItem: 0,
      page: {
        pageIndex: 1,
        pageSize: 8,
      },
      loading: false,
      lists: [],
      currentCate: null,
      classLoading: false,
      searchKey: "",
    };
  },
  methods: {
    // 检索bar点击查询
    searchBarClick() {
      this.page.pageIndex = 1;
      this.getClasses();
    },
    handlePageChange(index) {
      this.page.pageIndex = index;
      this.getClasses();
    },
    async getClasses() {
      const { list, totalItem } = await this.$axios.post(getTrainList, {
        ...this.page,
        categoryId: this.currentCate,
        courseName: this.searchKey,
      });
      this.lists = list || [];
      this.totalItem = totalItem;
    },
    cateChange(cateId) {
      this.currentCate = cateId;
      this.getClasses();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.con {
  background: $home-bg;
  padding: 20px;
  &-inner {
    width: $max-width;
    margin: 0 auto 20px auto;
    min-height: 500px;
  }
  &-lists {
    display: grid;
    grid-template-columns: repeat(4, calc(25% - 12px));
    gap: 15px;
  }
  &-search {
    border-top: 1px solid #f3f3f3;
    background: white;
    padding: 15px 20px;
    margin-bottom: 20px;
  }
}
</style>
